import React from 'react';
import { Chip } from '@mui/material';

/** A reviewed row's statuses (see checkRows), with their chips' labels and colours. */
export const USER_IMPORT_REVIEW_STATUSES = {
	ready: { label: 'Ready', color: 'success' },
	warning: { label: 'Warning', color: 'warning' },
	error: { label: 'Error', color: 'error' },
};

/** A reviewed import row's status as a coloured chip: ready, warning or error. */
export const UserImportReviewStatusChip = ({ status }) => (
	<Chip size='small' {...USER_IMPORT_REVIEW_STATUSES[status]} />
);
